// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		//Call function with browser is resized.
		// $(window).resize(function (event) {
		// 	resizeWindow();
		// });
		// resizeWindow();

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		if ($(window).width() > 600) {
			let footer = document.getElementById('footer');
			var heightFooter = footer.offsetHeight;
			let main = document.getElementById('content');
			main.style.marginBottom = heightFooter+"px";


			const columns_form = document.querySelector('.columns-form');
			if(columns_form){
				const form_gdpr =  columns_form.querySelector('.gdpr-wrap');
				const column1 = document.createElement('div');
				column1.setAttribute('class', 'column-wrapper column1-wrapper');
				form_gdpr.insertAdjacentElement('beforebegin',column1);

				const column2 = document.createElement('div');
				column2.setAttribute('class', 'column-wrapper column2-wrapper');
				form_gdpr.insertAdjacentElement('beforebegin',column2);

				const column1_fields = columns_form.querySelectorAll('.column1');
				for(let c1 = 0; c1 < column1_fields.length; c1++){
					column1.appendChild(column1_fields[c1]);
				}

				const column2_fields = columns_form.querySelectorAll('.column2');
				for(let c2 = 0; c2 < column2_fields.length; c2++){
					column2.appendChild(column2_fields[c2]);
				}


			}
		}
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}